/**
 * Simple event emitter for handling 402 Payment Required responses globally
 */

type InsufficientCreditsData = {
    message?: string;
    topUpUrl?: string;
};

type EventCallback = (data: InsufficientCreditsData) => void;

class InsufficientCreditsEventEmitter {
    private listeners: EventCallback[] = [];

    /**
     * Subscribe to insufficient credits events
     */
    subscribe(callback: EventCallback): () => void {
        this.listeners.push(callback);

        // Return unsubscribe function
        return () => {
            const index = this.listeners.indexOf(callback);
            if (index > -1) {
                this.listeners.splice(index, 1);
            }
        };
    }

    /**
     * Emit an insufficient credits event
     */
    emit(data: InsufficientCreditsData): void {
        this.listeners.forEach(callback => callback(data));
    }
}

export const insufficientCreditsEmitter = new InsufficientCreditsEventEmitter();
